import { render, staticRenderFns } from "./ProdView.vue?vue&type=template&id=6d2e8f8a&scoped=true&"
import script from "./ProdView.vue?vue&type=script&lang=js&"
export * from "./ProdView.vue?vue&type=script&lang=js&"
import style0 from "./ProdView.vue?vue&type=style&index=0&id=6d2e8f8a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d2e8f8a",
  null
  
)

export default component.exports